// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1uOah","productName":"Table_productName__1P6Q4"};